// extracted by mini-css-extract-plugin
export default {"toolbar":"lsf-toolbar","toolbar__group":"lsf-toolbar__group","toolbar_expanded":"lsf-toolbar_expanded","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630384053
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  